import {
  addLocalStorage,
  getLocalStorage,
  removeLocalStorage
} from '../../../infra/storage/localStorage'

export const getUserIri = () => {
  const user = getLocalStorage('user')
  if (user) {
    const data = JSON.parse(user)
    return `/users/${data.id}`
  }

  return null
}

export const getUser = () => {
  const user = getLocalStorage('user')
  if (user) {
    return JSON.parse(user)
  }
}

export const setUser = async (user: any) => {
  await addLocalStorage('user', JSON.stringify(user))
}

export const removeUser = () => {
  removeLocalStorage('user')
}
